import { render, staticRenderFns } from "./DeleteItem.vue?vue&type=template&id=368a820a&"
import script from "./DeleteItem.vue?vue&type=script&lang=js&"
export * from "./DeleteItem.vue?vue&type=script&lang=js&"
import style0 from "./DeleteItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports